import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcoEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 36,
	height: 36,
	fill: "none",
	viewBox: "0 0 36 36",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M10.615 27.542 26.03 12.155 23.736 9.86 8.335 25.247l-1.353 3.03q-.09.221.088.412.191.205.426.133zm16.578-16.534 1.353-1.31q.515-.514.53-1.044.03-.53-.427-.985l-.412-.427q-.456-.441-.985-.397-.515.045-1.03.53l-1.338 1.323z"
	})
});
export default SvgIcoEdit;
